<template>
  <section v-editable="blok" hero-image :style="[bgStyle]" :data-theme="blok.theme || 'dark'">
    <div class="container container--bleed">
      <div class="section-row">
        <div class="section-content">
          <Breadcrumbs v-if="!blok?.hide_breadcrumbs"></Breadcrumbs>
          <label v-if="blok.header && blok.header.length > 0" class="section-header" v-text="blok.header"></label>
          <div v-if="blok.subtitle && blok.subtitle.length > 0" class="section-subtitle" v-html="blok.subtitle"></div>
          <h1 v-if="hasRichTextContent(blok?.title)" class="section-title" v-html="title"></h1>
          <div v-if="hasRichTextContent(blok?.description)" class="section-description" v-html="description"></div>
          <div v-if="blok.buttons && blok.buttons.length > 0" class="section-buttons">
            <StoryblokComponent v-for="button in blok.buttons" :key="button._uid" :blok="button" />
          </div>
        </div>
        <figure class="section-image" :class="{ 'has-mobile': props.blok?.image_mobile?.filename }">
          <NuxtImg v-if="blok?.image?.filename" provider="storyblok" :src="blok.image.filename" :alt="`Card Image`" class="image-element" loading="lazy" :width="getImageDimensions(blok.image.filename).width" :height="getImageDimensions(blok.image.filename).height" />
          <NuxtImg v-if="blok?.image_mobile?.filename" provider="storyblok" :src="blok.image_mobile.filename" :alt="`Card Image Mobile`" class="image-element-mobile" loading="lazy" :width="getImageDimensions(blok.image_mobile.filename).width" :height="getImageDimensions(blok.image_mobile.filename).height" />
        </figure>
      </div>
    </div>
  </section>
</template>
<script setup lang="ts">
  import type { HeroImageStoryblok } from "~/types/storyblok";
  import { getImageDimensions, optimizeImage, hasRichTextContent } from "#imports";

  interface Props {
    blok: HeroImageStoryblok;
  }

  const props = defineProps<Props>();
  const title = computed(() => useRichText(props.blok?.title || {}));
  const description = computed(() => useRichText(props.blok?.description || {}));
  const bgStyle = computed(() => {
    if (!props.blok.background?.filename) return {};
    return {
      backgroundImage: `url(${props.blok.background?.filename})`,
    };
  });
</script>
<style src="~/assets/scss/section/hero-image.scss" lang="scss"></style>
